module.exports = __webpack_public_path__ + "static/media/fundraiser-step-3.79144e1c.svg";